/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".i-swipers[_ngcontent-%COMP%]{display:none;width:100%;justify-content:space-between}@media screen and (max-width:929px){.i-swipers[_ngcontent-%COMP%]{display:flex}}.i-swipers__arrow[_ngcontent-%COMP%]{opacity:0;transition:opacity .25s ease}.i-swipers__arrow.is-visible[_ngcontent-%COMP%]{opacity:.7}.i-swipers__left[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{transform:rotate(180deg)}.i-swipers[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{width:20px;height:auto}"];
export { styles as styles };
